import Mixtape from "./Mixtape"
import styles from "../styles/Mixtapes.module.scss"

const Mixtapes = ({ mixtapes }) => {
  const cutoutShapes = ["circle", "triangle", "topBar", "none"]
  return (
    <div className={styles.mixtapes}>
      {mixtapes.map((mixtape, index) => {
        return (
          <Mixtape
            key={mixtape.slug}
            slug={mixtape.slug}
            name={mixtape.name}
            id={mixtape.id}
            imageUrl={mixtape.imageUrl}
            cutoutShape={cutoutShapes[index % 4]}
          />
        )
      })}
    </div>
  )
}

export default Mixtapes
